module.exports = {
      id: "construction-usage",
      viewBox: "0 0 19 21.3",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#construction-usage",
      toString: function () {
        return this.url;
      }
    }